<template>
    <b-row id="commissions_total_component"
           class="commissions_total_component">
        <b-col lg="6" cols="12">
            <div class="commissions-total-label">
                <p>Total income:</p>
            </div>
            <div class="commissions-total-value">
                <p>{{ totalIncome }}</p>
            </div>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        dependencies: ['money'],
        computed: {
            totalIncome () {
                return 'FND '  + this.money.format(this.$store.getters.totalIncomes.total_income.amount, 'fnd')
            }
        }
    }
</script>

<style lang="scss">
    @import '../../../../../../assets/scss/_colors.scss';

    .commissions-total-label{
        padding: 50px 0;
        border-bottom: 6px solid $base1;
    }

    .commissions-total-value{
        p{
            font-size: 36px;
        }
    }

    @media(max-width:991px){
        .commissions-total-label{
            padding: 30px 0;
        }

        .commissions-stats-component{
            margin: 30px -15px 30px!important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/commissions/CommissionsTotal.vue